
const userprofileview = [{"key":"userprofile.flash.ispublished","string":"Vaš profil je objavljen na platformi za strokovnjake."},{"key":"userprofile.flash.unpublish","string":"Kliknite tukaj za odstranitev objave."},{"key":"userprofile.flash.isnotpublished","string":"Vaš profil ni objavljen na platformi za strokovnjake."},{"key":"userprofile.flash.publish","string":"Kliknite tukaj za objavo."},{"key":null,"string":null}]

export default userprofileview



// WEBPACK FOOTER //
// ./src/i18n/sl/adduserprofile/userprofileview.js